import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGewerbekunde = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_2",
	"data-name": "Ebene 2",
	xmlns: "http://www.w3.org/2000/svg",
	width: 110,
	height: 100,
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#00488E",
			className: "cls-1",
			d: "m185.37,81.08c-8.4-1.47-31.97-1.67-45.94-.61V22.89s-3.98-.83-3.98-.83c-13.49-2.81-55.16-2.83-71.92-.04l-4.18.7v27.87c-12.8-1.3-35.49-1.02-45.58.88l-4.08.77v127.35h179.82v-97.78s-4.14-.72-4.14-.72Zm-126.02,88.51h-14.8v-19.74h-10.05v19.74h-14.8V60.7c11.21-1.28,30.12-1.17,39.66-.07v108.96Zm30.04,0v-39.47h20v39.47h-20Zm40.04,0h-10.04v-49.47h-40v49.47h-10.04V31.31c16.39-1.87,46.54-1.69,60.08-.08v138.36Zm50.08,0h-15.01v-19.79h-10.05v19.79h-15.01v-79.09c11.36-.95,30.33-.87,40.08-.05v79.14Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 34.46,
			y: 69.59,
			width: 10.05,
			height: 20.24
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 34.46,
			y: 99.77,
			width: 10.05,
			height: 20.12
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 154.44,
			y: 99.97,
			width: 10.05,
			height: 20.24
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 154.44,
			y: 130.14,
			width: 10.05,
			height: 10.06
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 84.36,
			y: 79.78,
			width: 10.05,
			height: 10.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 104.54,
			y: 79.78,
			width: 10.05,
			height: 10.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 104.54,
			y: 99.77,
			width: 10.05,
			height: 10.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 84.36,
			y: 99.77,
			width: 10.05,
			height: 10.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 84.36,
			y: 39.75,
			width: 10.05,
			height: 10.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 104.54,
			y: 39.75,
			width: 10.05,
			height: 10.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 104.54,
			y: 59.74,
			width: 10.05,
			height: 10.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 84.36,
			y: 59.74,
			width: 10.05,
			height: 10.05
		})
	]
});
export default SvgGewerbekunde;
